export enum ContentType {
  VIDEO = 'video',
  LIVE_STREAM = 'live_stream',
  CAMPAIGN = 'campaign',
  BLOG = 'blog',
  COMMUNITY_POST = 'community_post',
  PLAYLIST = 'playlist',
}
